// Services the apartment has switched on (admin-login: user.enabledServices; staff login also
// copies it to localStorage 'enabledServices'). Returns null when the login didn't send the list.
export function getEnabledServices(): string[] | null {
    try {
        const stored = JSON.parse(localStorage.getItem('enabledServices') || 'null');
        if (Array.isArray(stored)) {
            return stored;
        }
        const user = JSON.parse(localStorage.getItem('userData') || 'null');
        return Array.isArray(user?.enabledServices) ? user.enabledServices : null;
    } catch {
        return null;
    }
}

// Emergency is shown only when it's in enabledServices (older logins without the list keep it)
export function isEmergencyEnabled(): boolean {
    const services = getEnabledServices();
    return !services || services.includes('emergency');
}
